import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import { getBrandConfig } from './brand-config';
import './styles/index.css';
import './App.css';

const brandConfig = getBrandConfig();
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || 'dummy-client-id';
const DEV_BYPASS = import.meta.env.VITE_DEV_BYPASS_AUTH === 'true';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_URL || '';

if (document.title === 'Easy Street Brands' || document.title === 'Brand Automation') {
  document.title = `${brandConfig.name} Automation`;
}

const faviconLink = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
if (faviconLink) {
  faviconLink.href = brandConfig.logo;
  faviconLink.type = brandConfig.logo.endsWith('.avif') ? 'image/avif' : 'image/svg+xml';
}

// If dev bypass is enabled, we can use a dummy client ID
// Otherwise, we need a real one
const clientId = DEV_BYPASS ? 'dummy-client-id-for-dev' : GOOGLE_CLIENT_ID;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <App authApiBaseUrl={API_BASE_URL} />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
